import { fork, all } from 'redux-saga/effects';
import siteComponentSagas from 'yoda-site-components/lib/sagas';
import watchTrackOrderSaga from 'yoda-account-components/lib/sagas/TrackOrderSaga';
import watchCancelOrderSaga from 'yoda-account-components/lib/sagas/CancelOrderSaga';
import watchUpdatePaymentSaga from 'yoda-account-components/lib/sagas/UpdatePaymentSaga';
import watchMyListSaga from 'yoda-account-components/lib/sagas/MyListSaga';
import watchMyOrdersSaga from './MyOrdersSaga';
import watchOrderDetailsSaga from './OrderDetailsSaga';
import watchCurbsideSaga from './CurbsideSaga';
import watchMarketplaceReturnSaga from './MarketplaceReturnSaga';

const siteComponentSagaList = Object.values(siteComponentSagas.injectedSagas);
const productSagas = [
    watchTrackOrderSaga,
    watchCancelOrderSaga,
    watchMyOrdersSaga,
    watchOrderDetailsSaga,
    watchUpdatePaymentSaga,
    watchMyListSaga,
    watchCurbsideSaga,
    watchMarketplaceReturnSaga,
    ...siteComponentSagaList,
];

const injectedSagas = {};
for (const saga of productSagas) { // eslint-disable-line
    // 1. Check that every saga has a name
    if (!saga.sagaName) {
        throw new Error(
            `Every saga has to have sagaName property. For debug purposes: ${saga.toString()}`
        );
    }

    // 2. Check that we have only unique sagas (one could be from components, another the same one from shared)
    if (injectedSagas[saga.sagaName]) {
        throw new Error(
            `That saga ${saga.sagaName} was already registered. Only 1 instance for particular name is allowed`
        );
    }
    injectedSagas[saga.sagaName] = saga;
}

const productRootSaga = function* productRootSaga() {
    yield all(Object.values(injectedSagas).map((saga) => fork(saga)));
};

productRootSaga.injectedSagas = injectedSagas;

export default productRootSaga;
